export type NotificationType =
  | "RequestSubmitted"
  | "RequestAccepted"
  | "RequestRejected"
  | "RequestAssigned"
  | "RequestCompleted"
  | "ReworkRequested"
  | "ReworkRejected";

export const NOTIFICATION_TYPE_LABELS: Record<NotificationType, string> = {
  RequestSubmitted: "New request submitted",
  RequestAccepted: "Request accepted",
  RequestRejected: "Request rejected",
  RequestAssigned: "You were assigned to a request",
  RequestCompleted: "Request completed",
  ReworkRequested: "Rework requested",
  ReworkRejected: "Your rework request was denied",
};

export interface AppNotification {
  id: string;
  requestId: string;
  type: NotificationType;
  isRead: boolean;
  createdAt: string;
}
